import dayjs from 'dayjs';
import Helpers from '@Apis/helpers';
import constants, { QUANTITY, toISTDate, DEFAULT_CUR_ROUND_OFF } from '@Apis/constants';
import HideValue from '../../../Common/RestrictedAccess/HideValue';

const ListScreenKeys = ({ documentData }) => {
  const record = documentData;

  const getOperationLabel = (operation) => {
    switch (operation) {
      case 'good_receiving_note':
        return 'Purchase Receipt';
      case 'manufacturing_order':
        return 'Manufacturing Order';
      case 'good_receiving_note_internal_stock_transfer':
        return 'Internal Transfer Receipt';
      case 'good_receiving_note_external_stock_transfer':
        return 'External Transfer Receipt';
      default:
        return '-';
    }
  };

  const selectedUsers = record?.assignees?.map((assignee) => ({
    userId: assignee?.user_id,
    title: assignee?.first_name,
    identity: assignee?.identity,
  })) || [];

  return [
    {
      label: 'QC Rule #',
      value: record?.qcr_number,
    },
    {
      label: 'Title',
      value: record?.quality_control_name,
    },
    {
      label: 'OPERATIONS',
      value: record?.operations?.map((operation) => (
          `${getOperationLabel(operation)}, `
      )),
    },
    {
      label: 'Assignees',
      value: selectedUsers?.map((assignee) => (
        `${assignee?.title}, `
      )),
    },
    {
      label: 'Control Frequency',
      value: record?.control_frequency,
    },
    {
      label: 'Products',
      value: record?.products?.map((product) => (
        `${product?.product_sku_name}, `
      )),
    },
  ];

};

export default ListScreenKeys;